export default __webpack_public_path__ + "static/media/menu-bg@2x.59576f75.png";